import { kea } from 'kea'
import sceneLogic from '~/scenes/search/logic'

export default kea({
  connect: {
    props: [sceneLogic, ['startMessage', 'isCityOrWebcamActivity']]
  },

  actions: () => ({
    backgroundLoaded: url => ({ url })
  }),

  reducers: ({ actions }) => ({
    loadedImage: [
      '',
      {
        [actions.backgroundLoaded]: (_, { url }) => url
      }
    ]
  })
})
